import { render, staticRenderFns } from "./LabDataExport.vue?vue&type=template&id=9a2b4d30"
import script from "./LabDataExport.vue?vue&type=script&lang=js"
export * from "./LabDataExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports